import { render } from "./VirtualRedTagNotificationContact.vue?vue&type=template&id=633cc0e4&scoped=true&ts=true"
import script from "./VirtualRedTagNotificationContact.vue?vue&type=script&lang=ts"
export * from "./VirtualRedTagNotificationContact.vue?vue&type=script&lang=ts"

import "./VirtualRedTagNotificationContact.vue?vue&type=style&index=0&id=633cc0e4&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633cc0e4"]])

export default __exports__